import {resetALL} from "../../../../../.globals/redux/actions";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit"
import {clientQuery, clientMutation} from '../../../../../core/data/GraphQLApi';
import {endpoints} from '../../../../../core/defaultValues';
import { ExceptionManager } from '../../../../../core/logManager';
const route = "modules/driverPerformance/views/riskEventsTab/redux/slice";

const INIT_STATE = {
    // Profiles
    loadingProfiles: false,
    profiles: [],
    nextToken: null,
    error: null,
    // Risk Events
    loadingRiskEvents: false,
    riskEvents: [],
    nextTokenRiskEvents: null,
    totalRiskEvents: 0,
    errorRiskEvents: null,
    // Create Asset Profile Event
    loadingCreateAssetProfileEvent: false,
    createAssetProfileEvent: null,
    errorCreateAssetProfileEvent: null,
    // Update Asset Profile Event
    loadingUpdateAssetProfileEvent: false,
    updateAssetProfileEvent: null,
    errorUpdateAssetProfileEvent: null,
    // Delete Asset Profile Event
    loadingDeleteAssetProfileEvent: false,
    deleteAssetProfileEvent: null,
    errorDeleteAssetProfileEvent: null,
};

export const searchAssetProfiles = createAsyncThunk(
    'driverPerformance/riskEventsTab/searchAssetProfiles',
    async (payload, { rejectWithValue, dispatch }) => {
        try {

        const { conditions, sort, limit, nextToken } = payload || {};

        const response = await clientQuery(
            searchAssetProfiles.query,
            {
                conditions,
                sort,
                limit,
                nextToken,
            },
            endpoints.GRAPHQL_GENERAL_V2
        );
        return response?.data;
        } catch (error) {
            ExceptionManager(error, route, 'searchAssetProfiles');
            return rejectWithValue(error);
        }

    }
)

searchAssetProfiles.query = `
    query searchAssetProfiles(
    $conditions: [AssetProfileSearchInput]
    $sort: [AssetProfileSortInput]
    $limit: Int
    $nextToken: String
    ) {
    data: searchAssetProfiles(
        conditions: $conditions
        sort: $sort
        limit: $limit
        nextToken: $nextToken
    ) {
        items {
            id
            name
        }
        total
        nextToken
    }
    }
`;

export const searchAssetProfileEvents = createAsyncThunk(
    'driverPerformance/riskEventsTab/searchAssetProfileEvents',
    async (payload, { rejectWithValue, getState }) => {
        try {
            const { profileId, loadMore = true } = payload || {};
            const state = getState();
            const currentNextToken = loadMore ? state.driverPerformanceRiskEventsTabRedux.nextTokenRiskEvents : null;

            const response = await clientQuery(
                searchAssetProfileEvents.query,
                {
                    conditions: profileId ? [
                        { fields: ["profileId"], terms: [profileId.toString()], exact: true }
                    ] : [],
                    sort: [],
                    limit: 15,
                    nextToken: currentNextToken || '',
                    onlyConfigured: false
                },
                endpoints.GRAPHQL_GENERAL_V2
            );

            if (response.errors && response.errors.length > 0) {
                return rejectWithValue(response.errors[0].message);
            }

            return {
                items: response.searchAssetProfileEvents?.items || [],
                nextToken: response.searchAssetProfileEvents?.nextToken || null,
                total: response.searchAssetProfileEvents?.total || 0,
                loadMore
            };
        } catch (error) {
            ExceptionManager(error, route, 'searchAssetProfileEvents');
            return rejectWithValue(error.message || 'Failed to fetch risk events');
        }
    }
)

searchAssetProfileEvents.query = `
    query searchAssetProfileEvents(
        $conditions: [AssetProfileEventSearchInput]
        $sort: [AssetProfileEventSortInput]
        $limit: Int
        $nextToken: String
        $onlyConfigured: Boolean
    ) {
        searchAssetProfileEvents(
            conditions: $conditions
            sort: $sort
            limit: $limit
            nextToken: $nextToken
            onlyConfigured: $onlyConfigured
        ) {
            items {
                id
                profileId
                eventId
                eventName
                eventType
                eventCategory
                status
                coachable
                defaultSeverity
                severityParameters
            }
            total
            nextToken
        }
    }`

export const createAssetProfileEvent = createAsyncThunk(
    'driverPerformance/riskEventsTab/createAssetProfileEvent',
    async (payload, { rejectWithValue }) => {
        const { profileId, eventId, status, coachable, severityParameters } = payload || {};
        try {
            const response = await clientMutation(
                createAssetProfileEvent.mutation,
                {
                    profileId,
                    eventId,
                    status,
                    coachable,
                    severityParameters
                },
                endpoints.GRAPHQL_GENERAL_V2
            );
            return response.data;
        } catch (error) {
            ExceptionManager(error, route, 'createAssetProfileEvent');
            return rejectWithValue(error);
        }
    }
)

createAssetProfileEvent.mutation = `
mutation createAssetProfileEvent(
  $profileId: Int!
  $eventId: Int!
  $status: Boolean!
  $coachable: Boolean!
  $severityParameters: AWSJSON
) {
  createAssetProfileEvent(
    profileId: $profileId
    eventId: $eventId
    status: $status
    coachable: $coachable
    severityParameters: $severityParameters
  ) {
    id
    profileId
    eventId
    eventName
    eventType
    eventCategory
    status
    coachable
    severityParameters
    createdOn
    isDeleted
  }
}
`

export const updateAssetProfileEvent = createAsyncThunk(
    'driverPerformance/riskEventsTab/updateAssetProfileEvent',
    async (payload, { rejectWithValue }) => {
        const { profileId, eventId, status, coachable, severityParameters } = payload || {};
        try {
            const response = await clientMutation(
                updateAssetProfileEvent.query,
                {
                    profileId,
                    eventId,
                    status,
                    coachable,
                    severityParameters
                },
                endpoints.GRAPHQL_GENERAL_V2
            );
            return response.data;
        } catch (error) {
            ExceptionManager(error, route, 'updateAssetProfileEvent');
            return rejectWithValue(error);
        }
    }
)

updateAssetProfileEvent.query = `
mutation updateAssetProfileEvent(
  $profileId: Int!
  $eventId: Int!
  $status: Boolean
  $coachable: Boolean
  $severityParameters: AWSJSON
) {
  updateAssetProfileEvent(
    profileId: $profileId
    eventId: $eventId
    status: $status
    coachable: $coachable
    severityParameters: $severityParameters
  )
}
`

export const deleteAssetProfileEvent = createAsyncThunk(
    'driverPerformance/riskEventsTab/deleteAssetProfileEvent',
    async (payload, { rejectWithValue }) => {
        const { profileId, eventId } = payload || {};
        try {
            const response = await clientMutation(
                deleteAssetProfileEvent.query,
                {
                    profileId,
                    eventId
                },
                endpoints.GRAPHQL_GENERAL_V2
            );
            return response.data;
        } catch (error) {
            ExceptionManager(error, route, 'deleteAssetProfileEvent');
            return rejectWithValue(error);
        }
    }
)

deleteAssetProfileEvent.query = `
mutation deleteAssetProfileEvent(
  $profileId: Int!
  $eventId: Int!
) {
  deleteAssetProfileEvent(
    profileId: $profileId
    eventId: $eventId
  )
}
`
//Slice
const driverPerformanceRiskEventsTabRedux = createSlice({
    name: "driverPerformance/riskEventsTab",
    initialState: INIT_STATE,
    reducers: {
        resetRiskEventsTab(state, action) {
            return action.payload ? { ...state, ...action.payload } : INIT_STATE;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        //searchAssetProfiles
        builder.addCase(searchAssetProfiles.pending, (state, action) => {
            state.loadingProfiles = true;
        })
        builder.addCase(searchAssetProfiles.fulfilled, (state, action) => {
            state.loadingProfiles = false;
            state.profiles = action.payload?.items || [];
            state.nextToken = action.payload?.nextToken || null;
        })
        builder.addCase(searchAssetProfiles.rejected, (state, action) => {
            state.loadingProfiles = false;
            state.error = action.payload;
        })

        //searchAssetProfileEvents
        builder.addCase(searchAssetProfileEvents.pending, (state, action) => {
            const { loadMore } = action.meta.arg || {};
            if (!loadMore) {
                state.riskEvents = [];
                state.nextTokenRiskEvents = null;
            }
            state.loadingRiskEvents = true;
        })
        builder.addCase(searchAssetProfileEvents.fulfilled, (state, action) => {
            const { items, nextToken, total, loadMore } = action.payload;
            if (loadMore) {
                state.riskEvents = [...state.riskEvents, ...items];
            } else {
                state.riskEvents = items;
            }
            state.nextTokenRiskEvents = nextToken;
            state.totalRiskEvents = total;
            state.loadingRiskEvents = false;
        })
        builder.addCase(searchAssetProfileEvents.rejected, (state, action) => {
            state.loadingRiskEvents = false;
            state.riskEvents = [];
            state.nextTokenRiskEvents = null;
            state.errorRiskEvents = action.payload;
        })

        //createAssetProfileEvent
        builder.addCase(createAssetProfileEvent.pending, (state, action) => {
            state.loadingCreateAssetProfileEvent = true;
        })
        builder.addCase(createAssetProfileEvent.fulfilled, (state, action) => {
            state.loadingCreateAssetProfileEvent = false;
            state.createAssetProfileEvent = action.payload;
        })
        builder.addCase(createAssetProfileEvent.rejected, (state, action) => {
            state.loadingCreateAssetProfileEvent = false;
            state.errorCreateAssetProfileEvent = action.payload;
        })

        //updateAssetProfileEvent
        builder.addCase(updateAssetProfileEvent.pending, (state, action) => {
            state.loadingUpdateAssetProfileEvent = true;
        })
        builder.addCase(updateAssetProfileEvent.fulfilled, (state, action) => {
            state.loadingUpdateAssetProfileEvent = false;
            state.updateAssetProfileEvent = action.payload;
        })
        builder.addCase(updateAssetProfileEvent.rejected, (state, action) => {
            state.loadingUpdateAssetProfileEvent = false;
            state.errorUpdateAssetProfileEvent = action.payload;
        })

        //deleteAssetProfileEvent
        builder.addCase(deleteAssetProfileEvent.pending, (state, action) => {
            state.loadingDeleteAssetProfileEvent = true;
        })
        builder.addCase(deleteAssetProfileEvent.fulfilled, (state, action) => {
            state.loadingDeleteAssetProfileEvent = false;
            state.deleteAssetProfileEvent = action.payload;
        })
        builder.addCase(deleteAssetProfileEvent.rejected, (state, action) => {
            state.loadingDeleteAssetProfileEvent = false;
            state.errorDeleteAssetProfileEvent = action.payload;
        })
    }
});

export const { actions, reducer } = driverPerformanceRiskEventsTabRedux;

export const { resetRiskEventsTab } = actions;

export default reducer;